import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const RefundCancellationPage = () => {
  return <CMSPage pageType="refund-and-cancellation" />;
};

export default RefundCancellationPage;